import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';
import { IImage } from 'tbk-components/src/components/Image';
import AdvancedMedia from '../AdvancedMedia';
export interface IResourceCtaProps extends IBaseElementProps {
	heading?: string;
	/**
	 * @control richtext
	 */
	excerpt?: string;
	cta?: ILink;
	accentImage?: IImage;
	sizing?: 'small' | 'large';
}

// Styling note: This component has no gutter padding, it is expected the parent will handle that.

/**
 * Calian ResourceCta
 * @block
 * @icon performance
 */
const ResourceCta: React.FC<IResourceCtaProps> = ({
	accentImage,
	id,
	className,
	classNames = [],
	heading,
	excerpt,
	cta,
	sizing = 'large',
}) => {
	return (
		<div
			id={id}
			className={cn(
				'resource-cta',
				`resource-cta--${sizing}`,
				className,
				...classNames,
			)}
		>
			<div
				className={cn(
					'resource-cta__wrapper overflow-hidden position-relative rounded-5 z-0  py-md-6 py-5 px-5 px-md-5',
					sizing === 'large'
						? 'theme-bg-radial-gradient-one'
						: 'theme-bg-linear-gradient-one',
				)}
			>
				<div className="position-relative z-1 resource-cta__copy mw-604px ms-auto me-0">
					{heading && (
						<h2
							className={cn(
								'text-white mb-2',
								sizing === 'large' ? 'h3' : 'h5',
							)}
						>
							{heading}
						</h2>
					)}
					{excerpt && (
						<p
							className={cn(
								'mb-0 pt-1 text-white',
								sizing === 'large'
									? 'text-body-lg pe-xl-2'
									: 'text-body-sm',
							)}
							dangerouslySetInnerHTML={{
								__html: excerpt,
							}}
						/>
					)}

					{cta?.label && (
						<Button
							type="secondary"
							size="sm"
							classNames={['mt-4']}
							{...cta}
						/>
					)}
				</div>
				{accentImage && (
					<AdvancedMedia
						image={accentImage}
						classNames={[
							'resource-cta__accent-image opacity-50 position-absolute top-0 start-0 z-0',
						]}
					/>
				)}
			</div>
		</div>
	);
};

export default ResourceCta;
